import { NAME } from './constants';

export const SET_ALERT = `${NAME}/SET_ALERT`;
export const RESET_ALERT = `${NAME}/RESET_ALERT`;
export const TOGGLE_ALERT = `${NAME}/TOGGLE_ALERT`;
export const HIDE_ALERT = `${NAME}/HIDE_ALERT`;
export const NAVIGATE_TO = `${NAME}/NAVIGATE_TO`;
